import React,{ Component } from 'react';
import scrollToComponent from 'react-scroll-to-component';

import './style.css'
import '../ApplicantForm/style.css'

class ScolarshipResume extends Component {
  constructor() {
    super();
    this.state = { discount: 0 };
    this.onScolarhipChanged = this.onScolarhipChanged.bind(this);
  }

  onScolarhipChanged(e) {
    const { value } = e.target;
    this.setState((prev) => ({ ...prev, discount: parseInt(value, 10) }));

    setTimeout(() => {
      this.props.onScolarshipChanged(this.props.course, value);
    }, 200);
  }

  render() {
    const { course } = this.props;
    const { discount = 0 } = this.state;

    return <div className="course-description">
    <h2>{ course.school }</h2>
    <h3>
      { course.name }
      <small className="text-muted">{ course.level }</small>
    </h3>
    <div className="description"><p>{ course.description }</p></div>
    <div className="price">
      <div className="row">
        <div className="col-12">
          PRECIO ORIGINAL: { course.price && course.price !== 'No informado' ? course.price : 'No informado' }<br />
        </div>
        <div className="col-12">
          PRECIO FINAL: <strong>{ course.price && course.price !== 'No informado' ? `$ ${course.price - ( course.price * discount / 100 )}` : 'No informado' }</strong>
        </div>
      </div>
      <div className="row">
          <div className="col-12 col-md-1 option-col">
              <input onChange={ this.onScolarhipChanged } className="form-check-input" id={`scolarship_30-${course.id}`} value='30' type="radio" name={`scolarships-${course.id}`} />
              <label className="form-check-label" htmlFor="scolarship_30">30%</label>
          </div>
          <div className="col-12 col-md-1 option-col">
              <input onChange={ this.onScolarhipChanged } className="form-check-input" id={`scolarship_50-${course.id}`} value='50' type="radio" name={`scolarships-${course.id}`} />
              <label className="form-check-label" htmlFor="scolarship_50">50%</label>
          </div>
          <div className="col-12 col-md-1 option-col">
              <input onChange={ this.onScolarhipChanged } className="form-check-input" id={`scolarship_100-${course.id}`} value='100' type="radio" name={`scolarships-${course.id}`} />
              <label className="form-check-label" htmlFor="scolarship_50">100%</label>
          </div>
          <div className="col-12 col-md-3 option-col">
              <input onChange={ this.onScolarhipChanged } className="form-check-input" id={`scolarship_0-${course.id}`} value='0' type="radio" name={`scolarships-${course.id}`} />
              <label className="form-check-label" htmlFor="scolarship_0">No Necesito beca</label>
          </div>
    </div>
  </div>
  </div>
}
}

class ConfirmScolarhips extends Component {
  constructor() {
    super();
    this.onScolarhipChanged = this.onScolarhipChanged.bind(this);
  }

  onScolarhipChanged(course, value) {
    this.props.onConfirmScolarshipChanged(course, value);
  }

  componentDidMount() {
    scrollToComponent(this.confirmSection, { offset: 0, align: 'top', duration: 0 });
  }

  componentDidUpdate() {
    if (this.props.confirmed) {
      scrollToComponent(this.readySection, { offset: 0, align: 'top', duration: 0 });

    }
  }

  render() {
    if (this.props.confirmed) {
      return <section ref={(section) => this.readySection = section} className="applicant-form scolarship-resume scolarship-ready container">
        <div className="think text-center">
          <h3>¡Felicidades! ¡Ya estas inscripto!</h3> <br />
          Te vamos a informar el resultado del sorteo mediante el correo electrónico que proporcionaste.
        </div>
      </section>
    }

    return <section ref={(section) => this.confirmSection = section} className="applicant-form scolarship-resume container">
        <div className="think">
          <div className="text-center">
            <h2>Seleccioná el porcentaje de beca que necesites</h2>
          </div>
          <p>
            Al seleccionar un porcentaje de beca del programa <strong>Becas En Red</strong>,
            estas ocupando el lugar de alguien más que quizá no pueda acceder a dicho curso.
            ¡Es por esto que apelamos a tu conciencia! Selecciona el porcentaje que mejor se
            adecue a tus necesidades, dejando los porcentaje más altos a aquellos que realmente
            lo necesiten.
          </p>
        </div>
        <hr />
        { this.props.selected_courses.map((course, idx) => {
          return <React.Fragment key={ course.id }>
            <div>
                <ScolarshipResume onScolarshipChanged={ this.onScolarhipChanged } course={ course } />
            </div>
            { idx === 0 ? <hr /> : null }
          </React.Fragment>
        }) }
        {
          this.props.error
          ? <div class="alert alert-danger" role="alert">
             Ocurrio un error mientras guardabamos los datos. Re-intenta en un momento para no perder tu lugar.
            </div>
          : null
        }
        <div className="text-center">
          <button type="button" onClick={ this.props.onScolarshipConfirmed } className="btn btn-primary btn-lg">Enviar</button>
        </div>
    </section>
  }
}

export default ConfirmScolarhips;



// WEBPACK FOOTER //
// ./src/components/ConfirmScolarships/Component.js